import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'CreateAccountWithPassword.title',
    description: 'Create Account Title on Order Confirmation page',
    defaultMessage: 'Save your information for faster checkout!',
  },
  postOrderEmailLabelConfirmation: {
    id: 'CreateAccountWithPassword.postOrderEmailLabelConfirmation',
    description:
      'email address label for use on post order account confirmation',
    defaultMessage: 'Email Address: ',
  },
  errorTitle: {
    id: 'CreateAccountWithPassword.errorTitle',
    description: 'Generic error title shown when network request fails',
    defaultMessage: 'You caught us sleeping',
  },
  errorGenericMessage: {
    id: 'CreateAccountWithPassword.errorGenericMessage',
    description: 'Generic error message shown when network request fails',
    defaultMessage:
      'We’re running into a technical issue, please refresh your page and try again in a few minutes. Contact customer service for immediate assistance at ',
  },
  errorPhoneMessage: {
    id: 'CreateAccountWithPassword.errorPhoneMessage',
    description: 'Phone number to call if something happens when trying to create account',
    defaultMessage: '1-888-848-0965.',
  },
  prosForCreatingAccountTitleMobile: {
    id: 'CreateAccountWithPassword.prosForCreatingAccountTitleMobile',
    description:
      'Subtitle for account pros bulletpoints on Order Confirmation Screen on Mobile',
    defaultMessage: 'Why create a Purple account?',
  },
  prosForCreatingAccountTitleDesktop: {
    id: 'CreateAccountWithPassword.prosForCreatingAccountTitleDesktop',
    description:
      'Subtitle for account pros bulletpoints on Order Confirmation Screen Desktop',
    defaultMessage: 'Here’s what you’ll enjoy:',
  },
  prosForCreatingAccountBullet0: {
    id: 'CreateAccountWithPassword.prosForCreatingAccountBullet0',
    description: 'Creating Account Pros bulletpoint #1',
    defaultMessage: 'View past purchases and invoices',
  },
  prosForCreatingAccountBullet1: {
    id: 'CreateAccountWithPassword.prosForCreatingAccountBullet1',
    description: 'Creating Account Pros bulletpoint #2',
    defaultMessage: 'Find out about upcoming promotions',
  },
  prosForCreatingAccountBullet2: {
    id: 'CreateAccountWithPassword.prosForCreatingAccountBullet2',
    description: 'Creating Account Pros bulletpoint #3',
    defaultMessage: 'Quicker checkout with future purchases',
  },
  sendVerifyTitle: {
    id: 'CreateAccountWithPassword.sendVerifyTitle',
    description:
      'Verification banner Title that displays after successful account creation',
    defaultMessage: 'Perfect, You’re almost done!',
  },
  sendVerifyMessagePt1: {
    id: 'CreateAccountWithPassword.sendVerifyMessagePt1',
    description:
      'Verification banner body that displays after successful account creation part 1',
    defaultMessage: 'We’ve sent a verification email to ',
  },
  sendVerifyMessagePt2: {
    id: 'CreateAccountWithPassword.sendVerifyMessagePt2',
    description:
      'Verification banner body that displays after successful account creation part 2',
    defaultMessage: '. Be sure to verify your email to complete your account activation to track your purchases.',
  },
  unverifiedErrorPt1: {
    id: 'CreateAccountWithPassword.unverifiedErrorPt1',
    description: 'Login modal verify email message part 1',
    defaultMessage: 'We\'ve sent a verification email to ',
  },
  unverifiedErrorPt2: {
    id: 'CreateAccountWithPassword.unverifiedErrorPt2',
    description: 'Login modal verify email message part 2',
    defaultMessage: 'Verification is required before you can sign in. If you didn’t recieve an email, ',
  },
  unverifiedErrorPt3: {
    id: 'CreateAccountWithPassword.unverifiedErrorPt3',
    description: 'Login modal verify email message part 3',
    defaultMessage: 'Click here',
  },
  unverifiedErrorPt4: {
    id: 'CreateAccountWithPassword.unverifiedErrorPt4',
    description: 'Login modal verify email message part 4',
    defaultMessage: 'to resend the verification email.',
  },
  resendVerifyMessagePt1: {
    id: 'CreateAccountWithPassword.resendVerifyMessagePt1',
    description: 'Create account on thank you summary verification email resent message part 1',
    defaultMessage: 'Verification email resent to',
  },
  resendVerifyMessagePt2: {
    id: 'CreateAccountWithPassword.resendVerifyMessagePt2',
    description: 'Create account on thank you summary verification email resent message part 2',
    defaultMessage: '. It may take a few minutes.',
  },
});
